import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import VueApexCharts from "vue3-apexcharts";

const app = createApp(App)

app.use(VueApexCharts);
app.use(router)
app.use(i18n);

app.mount('#app')
